import React from "react";

function GasBased() {
  return (
    <div class="col-lg-8 col-md-12 col-sm-12 content-side">
      <div class="service-details-content">
        <div class="inner-box">
          <h2>Gas-Based Suppression System </h2>
          <figure class="image-box">
            <img
              src="/assets/images/CO2-fire-suppression-system.jpg"
              alt=""
            />
          </figure>
          <div class="text">
            <p>
              In addition to fire detection and alarm systems, buildings that
              have dedicated server/rack rooms should have a minimum-level gas
              suppression system. We provide a range of gas suppression systems
              including Novac,
Inergen,
FM200,
Kitchen Hood Systems,
Co2.

            </p>
        
          </div>
        </div>
      </div>
    </div>
  );
}

export default GasBased;
